import { combineReducers } from 'redux'
import modules from './modules'

export default combineReducers(modules)
